import axios from "axios";
import getItemFromLocalStorage from "utils/getItemFromLocalStorage";
import { trackEvent, ClarityEvents } from "utils/clarity";

// Create a custom event for token expiration
const dispatchTokenExpired = () => {
  window.dispatchEvent(new CustomEvent("tokenExpired"));
};

// Create a custom event for authentication required
const dispatchAuthRequired = () => {
  window.dispatchEvent(new CustomEvent("authRequired"));
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response, config } = error;

    if (response) {
      trackEvent(ClarityEvents.API_FAILURE, {
        status: response.status,
        url: config?.url?.substring(0, 100) || "unknown",
        method: config?.method || "unknown",
      });

      if (response.status === 401) {
        const user = getItemFromLocalStorage("user");
        if (user) {
          console.log(
            "Token expired, clearing storage and redirecting to login"
          );
          localStorage.clear();
          dispatchTokenExpired();
          dispatchAuthRequired();
        }
      }
    }

    return Promise.reject(error);
  }
);

export default axios;
